// BYOK config, persisted in localStorage. Keys are stored per provider so the
// user can switch vendors without re-entering them. Nothing is sent anywhere
// except directly to the selected vendor's API from the browser.

export type ProviderId = 'anthropic' | 'openai' | 'gemini'

export type AiConfig = {
	provider: ProviderId,
	model: string,
	apiKeys: { [k in ProviderId]?: string },
}

const LS_KEY = 'contenthub.ai'

export function loadConfig(): AiConfig {
	try {
		const raw = window.localStorage.getItem(LS_KEY)
		if (raw) return { apiKeys: {}, ...JSON.parse(raw) }
	}
	catch { /* ignore malformed config */ }
	return { provider: 'openai', model: 'gpt-4o', apiKeys: {} }
}

export function saveConfig(cfg: AiConfig) {
	window.localStorage.setItem(LS_KEY, JSON.stringify(cfg))
}
